import React from 'react';
import CompetitionShell from './competition/CompetitionShell';
import CompetitionRenderer from './competition/CompetitionRenderer';
import { pickLocalizedText } from '../../utils/localizedContent';

export default function BracketView({ 
  event,
  bracket, 
  isAdmin,
  hasEventsPermission, 
  participants,
  onGenerateBracket,
  onStartSwiss,
  onNextSwissRound,
  onAdvanceGroups,
  onFinalizeTournament,
  onCancelTournament,
  onDeleteTournament,
  onSelectMatch,
  actionLoading,
  lang 
}) {
  const deployedParticipants = event?.participant_organization?.participants || [];
  const title = pickLocalizedText(lang, 'Competicion del Torneo', 'Tournament Competition');
  return (
    <CompetitionShell
      title={title}
      isAdmin={isAdmin}
      eventStatus={event?.status}
      bracket={bracket}
      actionLoading={actionLoading}
      onFinalizeTournament={onFinalizeTournament}
      onCancelTournament={onCancelTournament}
      onDeleteTournament={onDeleteTournament}
      participants={deployedParticipants}
      lang={lang}
    >
      <CompetitionRenderer
        event={event}
        bracket={bracket}
        hasEventsPermission={hasEventsPermission}
        participants={participants}
        onGenerateBracket={onGenerateBracket}
        onStartSwiss={onStartSwiss}
        onNextSwissRound={onNextSwissRound}
        onAdvanceGroups={onAdvanceGroups}
        onSelectMatch={onSelectMatch}
        actionLoading={actionLoading}
        lang={lang}
      />
    </CompetitionShell>
  );
}
